import React, { useState, useEffect } from 'react';

// import CollectionPreferences from "@amzn/awsui-components-console/collection-preferences";
import {
  Box,
  Container,
  Header,
  Pagination,
  Button
} from "@amzn/awsui-components-react";
import { Link, useLocation, useParams } from "react-router-dom";
import { getCleanedItemContent } from '../CloseHelperMethods';

function AppsCarouselComponent(props) {
  
  const [carouselIndex, setCarouselIndex] = React.useState(1);
  const { jsonContent, addOrEditAccess } = props;

  if (jsonContent?.items?.length) {
    return (<>
      <Container
        fitHeight
        header={
          <Header
            variant="h2"
          >
            <Link to={jsonContent?.items[carouselIndex - 1]?.link}><span style={{ color: "#006ce0", fontWeight: "700", fontSize: "20px", }}>{jsonContent?.items[carouselIndex - 1]?.title}</span></Link>
          </Header>
        }
        footer={
          <>
            {addOrEditAccess && (
              <Button
                iconAlign="right"
                iconName="edit"
                onClick={() => {
                  props?.onModifyClick(props?.item, jsonContent)
                }}>
                Modify
              </Button>
            )}
            <Box float='right'>
              <Pagination
                currentPageIndex={carouselIndex}
                onChange={({ detail }) => {

                  setCarouselIndex(detail?.currentPageIndex)
                }
                }
                pagesCount={jsonContent?.items?.length}
              />
            </Box>
          </>
        }
      >
        <p>{getCleanedItemContent(jsonContent?.items[carouselIndex - 1]?.description)}</p>

      </Container>
    </>)
  } else {
    return (<>
      <Container
        fitHeight
        header={
          <Header
            variant="h2"
          >
            <span style={{ color: "#006ce0", fontWeight: "700", fontSize: "20px", }}>{jsonContent?.title}</span>
          </Header>
        }
        footer={
          <>
            {addOrEditAccess && (
              <Button
                iconAlign="right"
                iconName="edit"
                onClick={() => {
                  props?.onModifyClick(props?.item, jsonContent)
                }}>
                Modify
              </Button>
            )}
          </>
        }
      >
        <p><span style={{ color: "#db0000" }}>No apps featured!</span></p>
      </Container>
    </>)
  }

}

export default AppsCarouselComponent;